<template>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          v-if="!hideClose"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{ title }}</h4>
      </div>
      <div class="modal-body">
        <slot><p v-html="text"></p></slot>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" v-on="cancelEvHandler">
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-primary"
          :class="disabled ? 'disabled' : ''"
          :disabled="disabled ? true : false"
          v-on="okEvHandler"
          @click="okConfirmation"
        >
          {{ okName || "Aceptar" }}
        </button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>
<script>
export default {
  props: [
    "text",
    "title",
    "okHandler",
    "name",
    "okName",
    "cancelHandler",
    "hideClose",
    "disabled",
  ],
  computed: {
    okEvHandler: function () {
      if (this.okHandler) return { click: this.okHandler };

      return {};
    },
    cancelEvHandler: function () {
      if (this.cancelHandler) {
        return { click: this.cancelHandler };
      }

      return { click: this.close };
    },
  },
  methods: {
    okConfirmation() {
      this.$emit("ok-click");
    },
    close() {
      if (this.name && this.name != "") this.$modal.hide(this.name);
      else this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  margin: 0;
  width: auto;

  .modal-header {
    padding-bottom: 0px;
    .modal-title {
      margin-left: 0px;
    }
    .close {
      margin-top: 0px;
      padding-top: 0px;
    }
  }
  .modal-body {
  }
  .modal-footer {
  }
}
</style>
